import { Helmet } from "react-helmet";
import StructuredData from "@/components/StructuredData";
import Navigation from "@/components/Navigation";
import Footer from "@/components/Footer";
import HeroClean from "@/components/checkliste/sections/HeroClean";
import CyberRisksFeatures from "@/components/checkliste/sections/CyberRisksFeatures";
import ChecklistPreviewCards from "@/components/checkliste/sections/ChecklistPreviewCards";
import TestimonialsCarousel from "@/components/checkliste/sections/TestimonialsCarousel";
import ExpertStatementClean from "@/components/checkliste/sections/ExpertStatementClean";
import LeadFormClean from "@/components/checkliste/sections/LeadFormClean";
import FAQClean from "@/components/checkliste/sections/FAQClean";
import FinalCTACard from "@/components/checkliste/sections/FinalCTACard";
import { StickyCTABar } from "@/components/checkliste/shared/StickyCTABar";
import { checklisteMetadata } from "@/config/checklisteConfig";

const CyberChecklisteLanding = () => {
  const breadcrumbSchema = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": [
      {
        "@type": "ListItem",
        "position": 1,
        "name": "Home",
        "item": "https://cyberversicherung-arztpraxis.de"
      },
      {
        "@type": "ListItem",
        "position": 2,
        "name": "Cyber-Checkliste",
        "item": "https://cyberversicherung-arztpraxis.de/cyber-checkliste"
      }
    ]
  };

  return (
    <>
      <Helmet>
        <title>{checklisteMetadata.title}</title>
        <meta name="description" content={checklisteMetadata.description} />
        <meta property="og:title" content={checklisteMetadata.title} />
        <meta property="og:description" content={checklisteMetadata.description} />
        <meta property="og:type" content="website" />
        <link rel="canonical" href="https://cyberversicherung-arztpraxis.de/cyber-checkliste" />
      </Helmet>

      <StructuredData data={breadcrumbSchema} />

      <div className="min-h-screen bg-background relative">
        {/* Fixed Gradient Overlay - reduziert */}
        <div 
          className="fixed inset-0 z-0 pointer-events-none opacity-30"
          style={{
            background: "radial-gradient(ellipse at top, hsl(var(--accent) / 0.15), transparent 50%), radial-gradient(ellipse at bottom, hsl(var(--destructive) / 0.1), transparent 50%)"
          }}
        />

        <Navigation />

        <main className="relative z-10">
          <HeroClean />
          <CyberRisksFeatures />
          <ChecklistPreviewCards />
          <LeadFormClean />
          <TestimonialsCarousel />
          <ExpertStatementClean />
          <FAQClean />
          <FinalCTACard />
        </main>

        <Footer />

        <StickyCTABar />
      </div>
    </>
  );
};

export default CyberChecklisteLanding;